module.exports = __webpack_public_path__ + "img/mouse-wheel.e6a5d2d7.svg";